import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const Banner = ({ content }) => {
    return (
        <div className={styles.banner}>
            <img
                src="https://x0.ifengimg.com/ucms/2024_04/9AD0658324F59A1D925B95808A130E74B9EB76C4_size150_w1180_h165.jpg"
                className={styles.bannerPic}
            />
        </div>
    );
};

Banner.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Banner);
